export default "__VITE_ASSET__d144988a__"